export const LOCAL_STORAGE_KEY = 'bl-dme-store'
